var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"back-menu-button",on:{"click":function($event){return _vm.$emit('click')}}},[_c('elm-arrows-arrow-left-bold-icon',{attrs:{"size":"12"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }